import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Modal, Input, Field, FieldGroup } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const EditAgeRate = ({ ageRate, onClose, onSave }) => {
  const [data, setData] = useState({
    id: null,
    quote_rate_id: null,
    payment_modes: []
  });
  const [populate_data, setPopulateData] = useState({
    ages: '',
    rates: ''
  });

  useEffect(() => {
    const new_age_rate = ageRate || {};
    const age_rates = {};

    [...Array(100)].forEach((_v, i) => {
      age_rates[`age_${i + 1}`] = new_age_rate[`age_${i + 1}`];
    });

    setData({
      id: new_age_rate.id,
      quote_rate_id: new_age_rate.quote_rate_id,
      payment_modes: new_age_rate.payment_modes || [],
      ...age_rates
    });
  }, [ageRate]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const handlePopulateChange = (name, e) => {
    setPopulateData({ ...populate_data, [name]: e.target.value });
  };

  const handlePopulate = () => {
    const ages = populate_data.ages.split('\n');
    const rates = populate_data.rates.split('\n');
    const updated_rates = {};

    ages.forEach((a, i) => {
      const age = a.trim();
      const rate = rates[i];

      if (rate) {
        updated_rates[`age_${age}`] = rate.trim();
      }
    });

    setData({ ...data, ...updated_rates });
  };

  const handleSave = () => {
    const { quote_rate_id, ...payload } = data;

    Api.updateQuoteRate(quote_rate_id, { age_rates_attributes: [payload] }).then(() => {
      onSave();
    });
  };

  return (
    <>
      <Modal
        buttons={[
          {
            children: data.id ? 'Save Changes' : 'Create Age Rate Set',
            onClick: handleSave,
            style: { marginLeft: 'auto' }
          }
        ]}
        maxWidth={600}
        onClose={onClose}
        title={data.id ? 'Editing Age Rate Set' : 'New Age Rate Set'}
      >
        <div style={{ padding: 30 }}>
          <Field>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'payment_modes')}
              options={[
                { value: 'monthly', label: 'Monthly' },
                { value: 'quarterly', label: 'Quarterly' },
                { value: 'semi_annual', label: 'Semi-Annual' },
                { value: 'annual', label: 'Annual' }
              ]}
              selected={data.payment_modes}
            />
          </Field>
          <FieldGroup contained={true} label='Age Rates'>
            <div style={{ display: 'flex', marginBottom: 10 }}>
              <Input
                height={160}
                onChange={handlePopulateChange.bind(null, 'ages')}
                placeholder='New Line Delimited Ages'
                style={{ flex: 1, marginRight: 5 }}
                type='textarea'
                value={populate_data.ages}
              />
              <Input
                height={160}
                onChange={handlePopulateChange.bind(null, 'rates')}
                placeholder='New Line Delimited Rates'
                style={{ flex: 1, marginLeft: 5 }}
                type='textarea'
                value={populate_data.rates}
              />
            </div>
            <Button
              inline={true}
              onClick={handlePopulate}
              small={true}
              style={{ marginBottom: 20 }}
            >
              Populate
            </Button>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between'
              }}
            >
              {[...Array(100)].map((_v, i) => {
                const num = i + 1;

                return (
                  <div
                    key={num}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: 110,
                      margin: '5px 0'
                    }}
                  >
                    <div style={{ width: 40, textAlign: 'right', marginRight: 10 }}>{num}</div>
                    <Input
                      onChange={handleInputChange.bind(null, `age_${num}`)}
                      value={data[`age_${num}`]}
                    />
                  </div>
                );
              })}
            </div>
          </FieldGroup>
        </div>
      </Modal>
    </>
  );
};

EditAgeRate.propTypes = {
  ageRate: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func
};

export default EditAgeRate;
